/**
 * Accent token system — Tempo Design System v1.0
 *
 * Semantic groups (pair with the Brand vs. Action separation):
 *   action  → Action Blue (primary interactive accent)
 *   brand   → Brand Slate (decorative / informational only)
 *   success → completed / achieved
 *   warning → attention / pending
 *   danger  → error / destructive (reserved, use sparingly)
 *
 * Backwards-compat aliases kept so existing callers using
 * "orange/blue/amber/green" continue to render — but they now resolve
 * to the new palette.
 */

const TOKENS = {
    action: {
        bg: "bg-action-soft",
        text: "text-action",
    },
    brand: {
        bg: "bg-brand-soft",
        text: "text-brand",
    },
    success: {
        bg: "bg-success-soft",
        text: "text-success",
    },
    warning: {
        bg: "bg-warning-soft",
        text: "text-warning",
    },
    danger: {
        bg: "bg-danger-soft",
        text: "text-danger",
    },
};

const ALIASES = {
    orange: "action",
    blue: "brand",
    amber: "warning",
    green: "success",
    rose: "danger",
};

const resolve = (name) => TOKENS[name] || TOKENS[ALIASES[name]] || TOKENS.action;

export const accentBadge = new Proxy(TOKENS, {
    get(_target, key) {
        return resolve(String(key));
    },
});

export const accentBadgeHover = new Proxy(
    {},
    {
        get(_target, key) {
            const t = resolve(String(key));
            return `bg-mist/60 text-ink-mute group-hover:${t.bg} group-hover:${t.text}`;
        },
    },
);
